import { Alert, Button, Card, Col, Row, Space, Table, Typography } from 'antd';
import { useGetDealsListQuery } from '../../apis/dealAPI';
import { formatDate } from '@/utils/commonUtils';
import { useEffect, useRef, useState } from 'react';
import useScrollToTop from '@/hooks/useScrollTop';
import TableTitle from '@/components/Elements/Heading/TableTitle';
import { displayError } from '@/utils/displayMessageUtils';
import { useAppSelector } from '@/hooks/hooks';
import { useResendRegisterEmailMutation } from '@/store/apis/authApi';
import { message } from 'antd';

const SettledPage = () => {
  const {
    data: dealsData,
    isLoading: dealsLoading,
    error: dealsError,
  } = useGetDealsListQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const hasShownErrorRef = useRef(false);

  const [dealData, setDealData] = useState<any>([]);

  useScrollToTop();

  const [emailNotVerified, setEmailNotVerified] = useState(false);

  const [resendRegisterEmail, { isLoading: isResending }] =
    useResendRegisterEmailMutation();

  useEffect(() => {
    if (dealsError && !hasShownErrorRef.current) {
      let message = '';
      if (
        'data' in dealsError &&
        typeof dealsError.data === 'object' &&
        dealsError.data !== null
      ) {
        message = (dealsError.data as any).error || '';
        console.log(message);
      }
      if (message.toLowerCase().includes('email not verified')) {
        setEmailNotVerified(true);
      }
      // displayError(dealsError);
      hasShownErrorRef.current = true;
    }
  }, [dealsError]);

  useEffect(() => {
    if (dealsData) {
      const tempData = dealsData.data.filter(
        (item: any) =>
          item.deal_stage_name === 'Completed and Sent' ||
          item.deal_stage_name === 'Settled',
      );
      setDealData(tempData);
      // setDealData(dealsData.data);
    }
  }, [dealsData]);

  console.log(dealsData);
  console.log('martin');

  const handleRequestReview = () => {};

  const columns: any = [
    // {
    //   title: <TableTitle>S.N</TableTitle>,
    //   dataIndex: 'sn',
    //   key: 'sn',
    //   align: 'center',
    //   render: (_: any, __: any, index: number) => (
    //     <Typography.Text strong>{index + 1}</Typography.Text>
    //   ),
    //   width: 100,
    // },
    {
      title: <TableTitle>Object ID</TableTitle>,
      dataIndex: 'hs_object_id',
      key: 'hs_object_id',
      align: 'center',
      render: (text: string) => (
        <Typography.Text>{text || 'N/A'}</Typography.Text>
      ),
      width: 200,
    },
    {
      title: <TableTitle>Deal Name</TableTitle>,
      dataIndex: 'dealname',
      key: 'dealname',
      align: 'center',
      render: (text: string) => (
        <Typography.Text>{text || 'N/A'}</Typography.Text>
      ),
      width: 200,
    },
    {
      title: <TableTitle>Lender</TableTitle>,
      dataIndex: 'lender',
      key: 'lender',
      align: 'center',
      render: (text: string) => (
        <Typography.Text>{text || 'N/A'}</Typography.Text>
      ),
      width: 200,
    },
    {
      title: <TableTitle>Loan Type</TableTitle>,
      dataIndex: 'loan_type',
      key: 'loan_type',
      align: 'center',
      render: (text: string) => (
        <Typography.Text>{text || 'N/A'}</Typography.Text>
      ),
      width: 200,
    },
    // {
    //   title: <TableTitle>Deal Stage</TableTitle>,
    //   dataIndex: 'deal_stage_name',
    //   key: 'deal_stage_name',
    //   align: 'center',
    //   render: (text: string) => {
    //     const color = text === 'settled' ? 'orange' : 'green';
    //     return (
    //       <Tag color={color} style={{ textAlign: 'center', display: 'block' }}>
    //         {text.toUpperCase()}
    //       </Tag>
    //     );
    //   },
    //   width: 200,
    // },
    // {
    //   title: <TableTitle>Last Review Date</TableTitle>,
    //   dataIndex: 'lastReviewDate',
    //   key: 'lastReviewDate',
    //   align: 'center',
    //   render: (
    //     _: any,
    //     { lastReviewDate }: { lastReviewDate: string | null },
    //   ) =>
    //     lastReviewDate ? (
    //       <Typography.Text>{formatDate(lastReviewDate)}</Typography.Text>
    //     ) : (
    //       <Typography.Text>N/A</Typography.Text>
    //     ),
    //   width: 200,
    // },
    // {
    //   title: <TableTitle>Next Review Date</TableTitle>,
    //   dataIndex: 'nextReviewDate',
    //   key: 'nextReviewDate',
    //   align: 'center',
    //   render: (
    //     _: any,
    //     { nextReviewDate }: { nextReviewDate: string | null },
    //   ) =>
    //     nextReviewDate ? (
    //       <Typography.Text>{formatDate(nextReviewDate)}</Typography.Text>
    //     ) : (
    //       <Typography.Text>N/A</Typography.Text>
    //     ),
    //   width: 200,
    // },
    // {
    //   title: <TableTitle>Create Date</TableTitle>,
    //   dataIndex: 'createdate',
    //   key: 'createdate',
    //   align: 'center',
    //   render: (_: any, { createdate }: { createdate: string | null }) =>
    //     createdate ? (
    //       <Typography.Text>{formatDate(createdate)}</Typography.Text>
    //     ) : (
    //       <Typography.Text>N/A</Typography.Text>
    //     ),
    //   width: 200,
    // },
    {
      title: <TableTitle>Action</TableTitle>,
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      render: () => (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <Button
            type="primary"
            size="small"
            onClick={() => handleRequestReview()}
          >
            Request Review
          </Button>
        </div>
      ),
      width: 200,
    },
  ];

  const { userData } = useAppSelector((state) => state.auth);

  const handleSendVerification = () => {
    message.loading('Sending verification email...');
    resendRegisterEmail({ email: userData?.email || '' });
  };

  return (
    <div style={{ width: '100%', marginTop: '20px' }}>
      {emailNotVerified && (
        <Alert
          banner
          message={
            <Space>
              <Typography.Text>
                Your email is not verified. Please verify it to access settled
                HubSpot data.
              </Typography.Text>
              <Button
                type="link"
                style={{
                  cursor: 'pointer',
                  color: '#1890ff',
                  textDecoration: 'underline',
                  fontSize: 14,
                  fontWeight: 'bold',
                }}
                onClick={handleSendVerification}
                loading={isResending}
              >
                Verify your email
              </Button>
            </Space>
          }
          type="warning"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}
      <Row>
        <Col xs={24} md={24}>
          <Card title="Settled Applications">
            <Table
              style={{ width: '100%' }}
              bordered
              dataSource={dealData}
              columns={columns}
              rowKey="id"
              loading={dealsLoading}
              pagination={{ pageSize: 5 }}
              scroll={{
                x: 'max-content',
              }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SettledPage;
